import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import InicioPantalla from "./componentes/Inicio Pantalla/InicioPantalla.jsx";
import Login from "./paginas/Login/Login.jsx";
import Tutorial from "./paginas/Tutorial/Tutorial.jsx";
import TutorialPanelPrincipal from "./paginas/Tutorial/TutorialPanelPrincipal.jsx";
import TutorialModulo from "./paginas/Tutorial/TutorialModulo.jsx";
import Home from "./paginas/Home/Home.jsx";
import CentroNavegacion from "./paginas/CentroNavegacion/CentroNavegacion.jsx";
import LayoutConMenu from "./componentes/Layout/LayoutConMenu.jsx";
import Ingresos from "./paginas/Ingresos/Ingresos.jsx";
import ProdEntradas from "./paginas/Produccion-Entradas/ProdEntradas.jsx";
import ProdSalidas from "./paginas/Produccion-Salidas/ProdSalidas.jsx";
import Produccion from "./paginas/Produccion/Produccion.jsx";
import Despachos from "./paginas/Despachos/Despachos.jsx";
import Registro from "./paginas/Registro/Registro.jsx";
import NavReportes from "./componentes/NavReportes/NavReportes.jsx";
import { ProdContextProvider } from "./context/ProductosContext.jsx";
import Demo from "./componentes/Demo/Demo.jsx";
import VoiceTestPage from "./componentes/VoiceTestPage/VoiceTestPage.jsx";
import QRTestPage from "./paginas/QRTest/QRTestPage.jsx";
import DeviceTestPage from "./paginas/DeviceTest/DeviceTestPage.jsx";
import CameraDebugPage from "./paginas/CameraDebug/CameraDebugPage.jsx";
import PDFDemo from "./componentes/PDFDemo/PDFDemo.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AutoReq from "./ComponentesGlobales/AutoReq.jsx";
import GlobalToastProvider from "./ComponentesGlobales/GlobalToastProvider.jsx";
import "./App.css";
import { useStoreLogin } from "./paginas/Login/useStoreLogin.js";
import Pos from "./paginas/Pos/Pos.jsx";
import PuntosVenta from "./paginas/PuntosVenta/PuntosVenta.jsx";
import ListasPrecios from "./paginas/ListasPrecios/ListasPrecios.jsx";
import Cajas from "./paginas/Cajas/Cajas.jsx";
import Seguridad from "./paginas/Seguridad/Seguridad.jsx";
import ConfiguracionArca from "./paginas/ConfiguracionArca/ConfiguracionArca.jsx";
import Pagos from "./paginas/Pagos/Pagos.jsx";
import RutaConPermiso from "./ComponentesGlobales/RutaConPermiso.jsx";
import { PERMISOS, ROLES } from "./servicios/sesionSeguridad.js";
import { permisosReportes } from "./config/navegacion.js";
import "./styles/appTheme.css";

const RedireccionReporte = ({ destino }) => {
  const location = useLocation();
  return <Navigate to={`${destino}${location.search}`} replace />;
};

function App() {
  useEffect(() => {
    const cerrarSesionInvalida = () => useStoreLogin.getState().logout({ notificarServidor: false });
    window.addEventListener("piseun:sesion-invalida", cerrarSesionInvalida);
    return () => window.removeEventListener("piseun:sesion-invalida", cerrarSesionInvalida);
  }, []);

  useEffect(() => {
    const getPublicIP = async () => {
      try {
        const services = [
          'https://api.ipify.org?format=json',
          'https://ipapi.co/json/',
          'https://jsonip.com'
        ];

        for (const service of services) {
          try {
            const response = await fetch(service);
            const data = await response.json();
            const ip = data.ip || data.query || data.IPv4;
            if (ip) {
              useStoreLogin.getState().registroAcceso(ip); 
              return;
            }
          } catch {
            continue;
          }
        }
      } catch {
        // El registro de acceso no debe impedir que la aplicación inicie.
      }
    };
    getPublicIP();
  }, []);

  return (
    <ProdContextProvider>
      <GlobalToastProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<InicioPantalla />} />
          <Route path="/login" element={<Login />} />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/tutorial/panel-principal" element={<TutorialPanelPrincipal />} />
          <Route path="/tutorial/ingreso-planta" element={<TutorialModulo modulo="ingresos" />} />
          <Route path="/tutorial/produccion" element={<TutorialModulo modulo="produccion" />} />
          <Route path="/tutorial/despachos" element={<TutorialModulo modulo="despachos" />} />
          <Route path="/tutorial/puntos-venta" element={<TutorialModulo modulo="puntos-venta" />} />
          <Route path="/tutorial/listas-precios" element={<TutorialModulo modulo="listas-precios" />} />
          <Route path="/tutorial/seguridad" element={<TutorialModulo modulo="seguridad" />} />
          <Route path="/tutorial/ventas" element={<TutorialModulo modulo="ventas" />} />
          <Route path="/tutorial/reportes" element={<TutorialModulo modulo="reportes" />} />
          <Route path="/registro" element={<Registro />} />
          {import.meta.env.DEV && <Route path="/pagos-preview" element={<Pagos modoVistaPrevia />} />}
          <Route element={<AutoReq />}>
            <Route element={<LayoutConMenu />}>
              <Route path="/home" element={<Home />} />
              <Route path="/gestion-produccion" element={<CentroNavegacion grupoId="operaciones" />} />
              <Route path="/centro-ventas" element={<CentroNavegacion grupoId="ventas" />} />
              <Route path="/centro-consultas" element={<CentroNavegacion grupoId="consultas" />} />
              <Route path="/catalogo-configuracion" element={<CentroNavegacion grupoId="configuracion" />} />
              <Route path="/ingreso-planta" element={<RutaConPermiso permiso={PERMISOS.PRODUCCION_ADMINISTRAR} requiereSuscripcion><Ingresos /></RutaConPermiso>} />
              <Route path="/produccion" element={<RutaConPermiso permiso={PERMISOS.PRODUCCION_ADMINISTRAR} requiereSuscripcion><Produccion /></RutaConPermiso>} />
              <Route path="/produccion-entradas" element={<RutaConPermiso permiso={PERMISOS.PRODUCCION_ADMINISTRAR} requiereSuscripcion><ProdEntradas /></RutaConPermiso>} />
              <Route path="/produccion-salidas" element={<RutaConPermiso permiso={PERMISOS.PRODUCCION_ADMINISTRAR} requiereSuscripcion><ProdSalidas /></RutaConPermiso>} />
              <Route path="/despachos" element={<RutaConPermiso permiso={PERMISOS.PEDIDOS_ADMINISTRAR} requiereSuscripcion><Despachos /></RutaConPermiso>} />
              <Route path="/reportes/*" element={<RutaConPermiso permisos={permisosReportes}><NavReportes /></RutaConPermiso>} />
              <Route path="/operadores" element={<RutaConPermiso permisos={[PERMISOS.USUARIOS_ADMINISTRAR, PERMISOS.SEGURIDAD_ADMINISTRAR]}><Seguridad /></RutaConPermiso>} />
              <Route path="/seguridad" element={<RutaConPermiso permisos={[PERMISOS.USUARIOS_ADMINISTRAR, PERMISOS.SEGURIDAD_ADMINISTRAR]}><Seguridad /></RutaConPermiso>} />
              <Route path="/pos" element={<RutaConPermiso permiso={PERMISOS.VENTAS_VER} requiereSuscripcion><Pos /></RutaConPermiso>} />
              <Route path="/comprobantes" element={<RutaConPermiso permiso={PERMISOS.COMPROBANTES_VER}><RedireccionReporte destino="/reportes/comercial/comprobantes" /></RutaConPermiso>} />
              <Route path="/notas-credito" element={<RutaConPermiso permiso={PERMISOS.NOTAS_CREDITO_VER}><RedireccionReporte destino="/reportes/comercial/notas-credito" /></RutaConPermiso>} />
              <Route path="/cuenta-corriente" element={<RutaConPermiso permiso={PERMISOS.CUENTA_CORRIENTE_VER}><RedireccionReporte destino="/reportes/comercial/cuenta-clientes" /></RutaConPermiso>} />
              <Route path="/puntos-venta" element={<RutaConPermiso permiso={PERMISOS.CONFIGURACION_ADMINISTRAR}><PuntosVenta /></RutaConPermiso>} />
              <Route path="/configuracion-arca" element={<RutaConPermiso rol={ROLES.SOPORTE}><ConfiguracionArca /></RutaConPermiso>} />
              <Route path="/listas-precios" element={<RutaConPermiso permiso={PERMISOS.PRECIOS_VER}><ListasPrecios /></RutaConPermiso>} />
              <Route path="/cajas" element={<RutaConPermiso permisos={[PERMISOS.REPORTES_VER, PERMISOS.REPORTES_CAJA_VER]}><RedireccionReporte destino="/reportes/caja/movimientos" /></RutaConPermiso>} />
              <Route path="/configuracion/cajas" element={<RutaConPermiso rol={ROLES.SOPORTE}><Cajas /></RutaConPermiso>} />
              {import.meta.env.DEV && <>
                <Route path="/demo" element={<Demo />} />
                <Route path="/voice-test" element={<VoiceTestPage />} />
                <Route path="/qr-test" element={<QRTestPage />} />
                <Route path="/camera-debug" element={<CameraDebugPage />} />
                <Route path="/device-test" element={<DeviceTestPage />} />
                <Route path="/pdf-demo" element={<PDFDemo />} />
              </>}
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />

        </Routes>
        <ToastContainer position="bottom-right" autoClose={2000} />
        </BrowserRouter>
      </GlobalToastProvider>
    </ProdContextProvider>
  );
}

export default App;
